exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settings-menu .menu-item[data-v-60f315bb] {\n  cursor: pointer;\n  transition: margin 0.3s ease;\n}\n.settings-menu .menu-item[data-v-60f315bb]:hover {\n    margin-left: 7.5px;\n}\n.settings-menu .menu-item[data-v-60f315bb]:not(:last-of-type) {\n    margin-bottom: 15px;\n}\n.settings-menu .menu-item.selected[data-v-60f315bb] {\n    font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-60f315bb","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/index.vue
// module id = 577
// module chunks = 0